import script from "./SuccessorNominationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessorNominationPanel.vue?vue&type=script&setup=true&lang=js"

import "./SuccessorNominationPanel.vue?vue&type=style&index=0&id=01a29c4c&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a29c4c"]])

export default __exports__